import { useEffect, useRef } from "react";
import { Loader2 } from "lucide-react";
import { exchangeSession } from "./adminApi";

// Handles the Emergent OAuth return: reads session_id from the URL fragment,
// exchanges it for a session cookie on the backend, then lands on /admin.
export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    if (!match) {
      window.location.replace("/admin");
      return;
    }
    exchangeSession(decodeURIComponent(match[1]))
      .catch(() => {})
      .finally(() => window.location.replace("/admin"));
  }, []);

  return (
    <div className="min-h-screen bg-[#050B26] flex items-center justify-center text-white">
      <div className="flex items-center gap-3 text-white/80" data-testid="auth-callback">
        <Loader2 className="animate-spin" size={22} />
        Signing you in…
      </div>
    </div>
  );
}
